import React from 'react';
import { Link } from 'react-router-dom';
import { AllEvents, VideoPerformances, CoreTeam, Recognitions, MediaPartners, SocialFollow } from '../components';
import './pages.css';

const HomePage = () => {
  return (
    <div className="page page--home">
      
      {/* Hero Section */}
      <section className="page__hero page__hero--home page__hero--compact page__hero--home-compact">
        <div className="page__hero-content">
          <p className="page__hero-kicker">Welcome to</p>
          <h1 className="gradient__text page__hero-title">Bollywood Ki Dhun</h1>
          <p className="page__hero-subtitle">Bringing South Asian talent to the North American stage</p>
          <div className="page__hero-ctas">
            <Link className="page__cta page__cta--primary" to="/events">Explore Events</Link>
            <Link className="page__cta page__cta--secondary" to="/about">Learn More</Link>
          </div>
        </div>
      </section>

      {/* Featured Content */}
      <div className="page__sections">
        <AllEvents />
        <VideoPerformances />
        <CoreTeam />
        <Recognitions />
        <MediaPartners />
        <SocialFollow />
      </div>
    </div>
  );
};

export default HomePage;
